import api from '@/common/api';

/* eslint-disable */

const initialState = () => ({
  domains: [],
  intervals: [],

  loading: {
    load: false,
    add: false,
    del: false,
    save: false,
    loadItem: false,
  },
  errors: {
    load: [],
    add: [],
    save: [],
    del: [],
  },
});

export default {
  namespaced: true,
  state: initialState,
  getters: {
    domains: (state) => state.domains,
    intervals: (state) => state.intervals,
    loading: (state) => state.loading,
    errors: (state) => state.errors,
  },
  mutations: {
    setDomains(state, domains) {
      state.domains = domains;
    },
    addDomain(state, item) {
      state.domains.push(item);
    },
    replaceDomain(state, { id, item }) {
      const ind = state.domains.findIndex(el => el.id === id);
      if (ind >= 0) {
        state.domains.splice(ind, 1, item);
      }
    },
    delDomain(state, id) {
        const ind = state.domains.findIndex(el => el.id === id);
        if (ind >= 0) {
          state.domains.splice(ind, 1);
        }
    },
    setIntervals(state, intervals) {
      state.intervals = intervals;
    },
    addInterval(state, item) {
        state.intervals.push(item);
    },
    replaceInterval(state, { id, item }) {
        const ind = state.intervals.findIndex(el => el.id === id);
        if (ind >= 0) {
          state.intervals.splice(ind, 1, item);
        }
    },
    delInterval(state, id) {
        const ind = state.intervals.findIndex(el => el.id === id);
        if (ind >= 0) {
          state.intervals.splice(ind, 1);
        }
    },

    startLoading(state, field) {
        state.loading[field] = true;
    },
    startLoadingId(state, { field, id }) {
        state.loading[field] = id;
    },
    endLoading(state, field) {
        state.loading[field] = false;
    },
    clearError(state) {
      state.errors = initialState().errors;
    },
    setError(state, { type, errors }) {
      state.errors[type] = errors;
    },

  },
  actions: {
    // DOMAINS
    async loadDomains({ commit, state, getters, rootGetters }  ) {
      commit('setDomains', []);
      commit('startLoading', 'load');
      try {
        const domains = await api.get('/constructor/domains/');
        commit('setDomains', domains ?? []);
      } catch (err) {
        console.log(err);
        commit('setError', { type: 'load', errors: err.data });
      } finally {
        commit('endLoading', 'load');
      }
    },

    // async loadDomain({ commit, state, dispatch }, id) {
    //   commit('startLoadingId', {field: 'load', id} );
    //   try {
    //     let response = await api.get(`/constructor/domains/${id}/`)
    //     if (response)
    //       commit('replaceDomain', {id, item: response});
    //     return response;
    //   } catch (err) {
    //     console.log(err.data);
    //     commit('setError', { type: 'save', errors: err.data });
    //   } finally {
    //     commit('endLoading', 'load');
    //   }
    // },

    async saveDomain({ commit, state, dispatch }, domain) {
      commit('startLoadingId', {field: 'save', id: domain.id} );
      try {
        let response = await api.patch(`/constructor/domains/${domain.id}/`, domain)
        if (response)
          commit('replaceDomain', {id: domain.id, item: response});
        return response;
      } catch (err) {
        console.log(err.data);
        commit('setError', { type: 'save', errors: err.data });
      } finally {
        commit('endLoading', 'save');
      }
    },

    async addDomain({ commit, state, dispatch }, domain) {
      commit('startLoading', 'add');
      commit('setError', { type: 'add', errors: [] });
      try {
        let response = await api.post(`/constructor/domains/`, domain)
        if (response)
          commit('addDomain', response);
        return response;
      } catch (err) {
        console.log(err.data);
        commit('setError', { type: 'add', errors: err.data });
      } finally {
        commit('endLoading', 'add');
      }
    },

    async delDomain({ commit, state, dispatch }, domain) {
      commit('startLoadingId', {field: 'del', id: domain.id} );
      try {
        await api.delete(`/constructor/domains/${domain.id}/`)
        commit('delDomain', domain.id);
        return true;
      } catch (err) {
        console.log(err);
        commit('setError', { type: 'del', errors: err.data });
      } finally {
        commit('endLoading', 'del');
      }
    },

    // INTERVALS
    async loadIntervals({ commit, state, getters, rootGetters }, ) {
      commit('setIntervals', []);
      commit('startLoading', 'load');
      try {
        const intervals = await api.get('/constructor/domain_intervals/');
        commit('setIntervals', intervals ?? []);
      } catch (err) {
        console.log(err);
        commit('setError', { type: 'load', errors: err.data });
      } finally {
        commit('endLoading', 'load');
      }
    },

    async loadInterval({ commit, state, dispatch }, id) {
      commit('startLoadingId', {field: 'load', id} );
      try {
        let response = await api.get(`/constructor/domain_intervals/${id}/`)
        if (response)
          commit('replaceInterval', {id, item: response});
        return response;
      } catch (err) {
        console.log(err.data);
        commit('setError', { type: 'save', errors: err.data });
      } finally {
        commit('endLoading', 'load');
      }
    },

    async saveInterval({ commit, state, dispatch }, interval) {
      commit('startLoadingId', {field: 'save', id: interval.id} );
      // commit('setError', { type: 'save', errors: [] });
      try {
        let response = await api.patch(`/constructor/domain_intervals/${interval.id}/`, interval)
        if (response)
          commit('replaceInterval', {id: interval.id, item: response});
        return response;
      } catch (err) {
        console.log(err.data);
        commit('setError', { type: 'save', errors: err.data });
      } finally {
        commit('endLoading', 'save');
      }
    },

    async addInterval({ commit, state, dispatch }, interval) {
      commit('startLoading', 'add');
      commit('setError', { type: 'add', errors: [] });
      try {
        let response = await api.post(`/constructor/domain_intervals/`, interval)
        if (response)
          commit('addInterval', response);
        return response;
      } catch (err) {
        console.log(err.data);
        commit('setError', { type: 'add', errors: err.data });
      } finally {
        commit('endLoading', 'add');
      }
    },

    async delInterval({ commit, state, dispatch }, interval) {
      commit('startLoadingId', {field: 'del', id: interval.id} );
      try {
        await api.delete(`/constructor/domain_intervals/${interval.id}/`)
        commit('delInterval', interval.id);
      } catch (err) {
        console.log(err);
        commit('setError', { type: 'del', errors: err.data });
      } finally {
        commit('endLoading', 'del');
      }
    },

  },

};
